"use client"
import { useSession } from "next-auth/react"
import dynamic from "next/dynamic"

const ChatWidget = dynamic(() => import("./ChatWidget"), { ssr: false })

export default function ChatWidgetWrapper() {
  const { status } = useSession()
  // ログイン前（未認証）の場合のみ表示
  if (status === "authenticated") return null
  return <ChatWidget />
}
